<template src="../templates/favourite-count.html" />

<script setup>

import { ref, onMounted } from "vue";

const favouriteCount = ref(0);

import { useStorage } from "../composables/useStorage";

// Listen for changes in local storage to update the count
onMounted(() => {
    favouriteCount.value = useStorage('favourites').length;

    window.addEventListener('storage', () => {
        setTimeout(() => {
            favouriteCount.value = useStorage('favourites').length;
        }, 100);
    });
});

</script>
